import { mergeStyles } from "@fluentui/react";
import { BREAKPOINT } from "../../commoncomponents/Constants.styles";
export const useEfdContainerStyles = mergeStyles({
    root: {
        "& .container-body": {
            display: "flex",
            flex: "none",
            flexWrap: "wrap",
            flexDirection: "row !important",
            justifyContent: "flex-start",
            paddingLeft: "2rem",
            paddingRight: "2rem",
            "& .tileContainer": {
                display: "flex",
                flexWrap: "wrap",
                textOverflow: "ellipsis",
            },
            [`@media (max-width: ${BREAKPOINT}px)`]: {
                flexFlow: "column nowrap!important",
                overflow: "auto",
                flex: "1",
            },
            [`@media (max-height: ${BREAKPOINT}px)`]: {
                flexFlow: "column nowrap!important",
                overflow: "auto",
                flex: "1",
            },
        },
    },
});
